/**
 * @voltxampere/web — Place category builtin commands (Sprint 22 C3)
 *
 * One palette command per registered `@voltxampere/ui` symbol. The
 * canonical 20-symbol set (resistor through op-amp) is iterated at
 * module init, so any symbol added in Sprint 23+ surfaces in the
 * palette automatically — no separate registration step.
 *
 * Each `place.<symbolId>` command:
 *   1. Sets `armedSymbol` to the canonical sym instance.
 *   2. Switches to the SİMÜLATÖR pane (Sprint 18 router).
 *
 * The canvas already listens to `armedSymbol` for stamp-mode entry.
 *
 * Copyright © 2026 360 Studio
 * Proprietary — All rights reserved.
 */

import { ALL_SYMBOLS } from "@voltxampere/ui";
import type { Command } from "../types.js";
import { armedSymbol } from "../../store/ui.js";
import { setPane } from "../../store/router.js";

export const PLACE_COMMANDS: readonly Command[] = ALL_SYMBOLS.map((sym) => ({
  id: `place.${sym.id}`,
  titleKey: `command.place.${sym.id}`,
  descriptionKey: `command.place.${sym.id}.desc`,
  category: "place" as const,
  shortcut: sym.shortcut,
  execute: () => {
    armedSymbol.value = sym;
    setPane("simulator");
  },
}));
